import { ITableColumn } from '@components/common/UTable/UTable';

import { TransformedDictionaries } from '@/api/dictionaries/types';
import { DOSAGE_UNIT_LABELS } from '@/shared/pharmacy/enum';
import { DAYS_OF_WEEK, DAYS_OF_WEEK_LABELS } from '@/shared/vaccination/enums';
import { sortDaysOfWeek } from '@/utils/dateUtils';
import { enumToOptions } from '@/utils/utils';

export const columns = (dictMap: TransformedDictionaries | undefined): ITableColumn[] => [
  {
    title: '№ п/п',
    dataIndex: 'index',
    width: 75,
  },
  {
    title: 'Вид исследования, обработки и прививки',
    dataIndex: 'researchTypeId',
    width: 350,
    render: (value: string) => dictMap?.RESEARCH_TYPE?.[value]?.name || '',
  },
  {
    title: 'Сдвиг при болезни',
    dataIndex: 'isSickDelay',
    render: (value) => (value ? 'Есть' : 'Нет'),
  },
  {
    title: 'Возраст (дней)',
    children: [
      {
        title: 'От',
        dataIndex: 'ageFrom',
        align: 'center',
      },
      {
        title: 'До',
        dataIndex: 'ageTo',
        align: 'center',
      },
    ],
  },
  {
    title: 'День недели',
    dataIndex: 'daysOfWeek',
    width: 100,
    render: (value: DAYS_OF_WEEK[]) => {
      if (value) {
        const sorted = sortDaysOfWeek(value);
        return sorted?.map((item: DAYS_OF_WEEK) => DAYS_OF_WEEK_LABELS[item])?.join(', ');
      }
      return;
    },
  },
  {
    title: 'Препарат',
    dataIndex: 'drugId',
    width: 350,
    render: (value: string) => dictMap?.DRUG?.[value]?.name || '',
  },
  {
    title: 'Единица дозировкии',
    dataIndex: 'dosageUnit',
    type: 'select',
    payload: {
      options: enumToOptions(DOSAGE_UNIT_LABELS),
    },
  },
  {
    title: 'Дозировка',
    children: [
      {
        title: 'мл',
        children: [
          {
            title: 'От',
            dataIndex: 'dosageFrom',
            align: 'center',
          },
          {
            title: 'До',
            dataIndex: 'dosageTo',
            align: 'center',
          },
        ],
      },
      {
        title: 'кг',
        dataIndex: 'dosageWeight',
        align: 'center',
      },
    ],
  },
  {
    title: 'Способ введения',
    dataIndex: 'administrationRouteIds',
    onCell: () => ({
      style: {
        maxWidth: 200,
        whiteSpace: 'normal',
        wordBreak: 'break-word',
      },
    }),
    render: (values: string[]) =>
      values
        ?.map((value: string) => dictMap?.ADMINISTRATION_ROUTE?.[value]?.name || '')
        ?.join(', ') || '',
  },
  {
    title: 'Минимальный процент использования тары (%)',
    dataIndex: 'minPackageThreshold',
    width: 100,
  },
];
